import { configureStore } from '@reduxjs/toolkit';
import pageReducer from './slices/pageSlice';
import formNameReducer from "./slices/formNameSlice";
import ultrasReducer from "./slices/ultrasSlice";
import promoTelegramReducer from './slices/promoTelegramSlice';
import crystalsReducer  from './slices/crystalsSlice';
import TasksSlice  from './slices/TasksSlice';
import budgetReducer from './slices/budgetSlice';
import promoTimeReducer from './slices/promoTimeSlice';
import promoFormReducer from './slices/promoFormSlice';
import selectedPromoReducer from './slices/selectedPromoSlice';
import paymentReducer from './slices/paymentSlice';
import promoSelectModeReducer from './slices/promoSelectModeSlice';

export const store = configureStore({
    reducer: {
        page: pageReducer,
        formName: formNameReducer,
        ultras: ultrasReducer,
        promoTelegram: promoTelegramReducer,
        crystals:     crystalsReducer,
        tasks: TasksSlice.reducer,
        budget: budgetReducer,
        promoTime: promoTimeReducer,
        promoForm: promoFormReducer,
        selectedPromo: selectedPromoReducer,
        payment: paymentReducer,
        promoSelectMode: promoSelectModeReducer,
    },
});

